<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="trafficCollectors"
      :items="trafficCollectors"
      :fields="trafficCollectorsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedTrafficCollectors"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      trafficCollectorsFields: [
        {key: 'collector_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'comments', label: this.$i18n.t('Comments'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedTrafficCollectors: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedTrafficCollectors = {
        collector_id: -1,
        name: '',
        comments: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditTrafficCollectorsSetting', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Traffic collectors"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_TRAFFIC_COLLECTORS', item.collector_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_TRAFFIC_COLLECTORS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedTrafficCollectors = item
      this.$root.$emit('bv::show::modal', 'modalEditTrafficCollectorsSetting', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    trafficCollectors () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/TRAFFIC_COLLECTORS']))
      copy.push({
        collector_id: 0,
        comments: 'Default',
        name: 'System',
        network_state: 0
      })
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_TRAFFIC_COLLECTORS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/trafficCollectors/main.vue